import { Image, Text, Heading, Flex, Center, Icon, Stack, useMediaQuery } from '@chakra-ui/react'
import * as React from 'react'
import { FiCornerDownLeft } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'
import { PageWrap } from '../../layouts'
import { images } from '../../theme'
import { SecondaryButton } from 'components/Buttons'

const PageNotFound: React.FC = () => {
  const history = useHistory()

  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  return (
    <PageWrap title="404" display="flex">
      <Center flex={1} flexDirection={isTabletOrMobile ? 'column' : 'row'}>
        <Center flex={1}>
          <Image w="90%" alt="nsoko property 404 image" bg="transparent" src={images[404]} />
        </Center>
        <Flex flex={1.4} flexDir="column" justify="space-around">
          <Stack>
            <Heading as="h2" fontWeight="extrabold" mb={3} size="4xl">
              Oops
            </Heading>
            <Heading as="h3" size="xl">
              we couldn&apos;t find that page.
            </Heading>
          </Stack>
          <Stack>
            <Text my={4} fontSize="xl">
              Maybe you can find what you need here.
            </Text>
            <Flex align="center" justify={isTabletOrMobile ? 'center' : 'flex-start'}>
              <SecondaryButton size="sm" onClick={() => history.push('/')}>
                <Text fontWeight="lighter">Back Home</Text>
              </SecondaryButton>
              <Icon mx={5} as={FiCornerDownLeft} />
            </Flex>
          </Stack>
        </Flex>
      </Center>
    </PageWrap>
  )
}

export default PageNotFound
